import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DataManipulationService} from '../../../services/common/data-manipulation.service';
import {AttachmentService} from '../../../services/attachment.service';

@Component({
    selector: 'app-localized-product-card',
    templateUrl: './localized-product-card.component.html',
    styleUrls: ['./localized-product-card.component.scss']
})
export class LocalizedProductCardComponent implements OnInit, OnChanges {

    @Input() product: any;
    @Input() oneLine = false;

    constructor(private attachmentService: AttachmentService,
                private dataManipulation: DataManipulationService,
    ) {
    }

    ngOnInit() {
        if (this.product) {
            this.initProduct();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.product) {
            this.initProduct();
        }
    }

    private initProduct() {
        if (this.product.attachment) {
            this.attachmentService.addExtraDataForOne(this.product.attachment);
        } else {
            Object.values<any>(this.product.attachments).forEach(prodAttachment => {
                this.attachmentService.addExtraDataForOne(prodAttachment.attachment);
                this.product.attachment = prodAttachment.attachment;
            });
        }
        if (this.product.localizations) {
            this.product = this.dataManipulation.addNameToElement(this.product);
        }
    }
}
